import type React from 'react';
import {
  Armchair,
  Building,
  ChefHat,
  Cigarette,
  ConciergeBell,
  Dog,
  Dumbbell,
  FileText,
  Home,
  Mountain,
  ParkingCircle,
  PawPrint,
  Shield,
  Sofa,
  Sparkles,
  Thermometer,
  Trees,
  Users,
  WashingMachine,
  Wifi,
  Zap,
} from 'lucide-react';
import { LucideIcon, type LucideIconComponent } from '@/src/components/LucideIcon';
import type { AmenitySubGroup } from '../utils/amenityGrouping';

const SUB_GROUP_ICONS: Partial<Record<AmenitySubGroup, LucideIconComponent>> = {
  Kitchen: ChefHat,
  Laundry: WashingMachine,
  Climate: Thermometer,
  'Interior features': Armchair,
  Connectivity: Wifi,
  'Outdoor spaces': Trees,
  'Scenic views': Mountain,
  Parking: ParkingCircle,
  Facilities: Building,
  'Pet facilities': PawPrint,
  Security: Shield,
  'Fitness and sports': Dumbbell,
  'Social and work spaces': Users,
  Services: ConciergeBell,
  'Lease terms': FileText,
  'Community type': Home,
  'Pet policy': Dog,
  'Parking policy': ParkingCircle,
  'Utilities included': Zap,
  Smoking: Cigarette,
  Furnishing: Sofa,
  'Special features': Sparkles,
};

export const getSubGroupIcon = (subGroup: AmenitySubGroup): React.ReactElement | null => {
  const SubGroupIcon = SUB_GROUP_ICONS[subGroup];
  if (!SubGroupIcon) return null;
  return <LucideIcon icon={SubGroupIcon} size="sm" />;
};
